export enum YmGoalCatalogItem {
  ItemAddToCart = 'itemAddToCart',
  OpenFromHome = 'catalogItemOpenFromHome',
  OpenFromPromotion = 'catalogItemOpenFromPromotion',
  OpenFromCatalog = 'catalogItemOpenFromCatalog',
  OpenFromSearcher = 'catalogItemOpenFromSearcher',
  OpenFromCart = 'catalogItemOpenFromCart',
  OpenFromCatalogItem = 'catalogItemOpenFromCatalogItem',
  OpenFromHelixBook = 'catalogItemOpenFromHelixBook',
  OpenFromOnco = 'catalogItemOpenFromOnco',
}
